import * as Yup from "yup";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, ImageCropper, Label, Modal } from "components";
import { icons } from "utils/constants";
import {
  deleteAccount,
  getUserDetails,
  throwError,
  updateUserDetails,
} from "store/globalSlice";
import { copyToClipboard, getDataFromLocalStorage } from "utils/helpers";
import { useAccount } from "wagmi";
import "./Admin.scss";

const Admin = ({ handleLogout }) => {
  const dispatch = useDispatch();
  const reduxData = useSelector((state) => state.global);
  // eslint-disable-next-line no-unused-vars
  const { isDarkMode } = reduxData || {};
  const { account_id, first_name, last_name, email_id } =
    getDataFromLocalStorage();
  const [isCopy, setIsCopy] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const account = useAccount();
  const { address } = account;

  const handleSave = async (values) => {
    setBtnLoading(true);
    const response = await dispatch(updateUserDetails(account_id, values));
    if (response?.status === 200) {
      setIsEdit(false);
      await dispatch(getUserDetails());
    }
    setBtnLoading(false);
  };

  const handleDelete = async () => {
    setDeleteLoader(true);
    const res = await dispatch(deleteAccount());
    setDeleteLoader(false);
    if (res?.status === 200) {
      handleLogout();
    } else {
      setIsDeletePopup(false);
    }
  };

  useEffect(() => {
    if (isCopy) {
      setTimeout(() => {
        setIsCopy(false);
      }, 1000);
    }
  }, [isCopy]);

  useEffect(() => {
    dispatch(getUserDetails())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validationSchema = Yup.object().shape({
    // first_name: Yup.string().required("First name is required."),
    // last_name: Yup.string().required("Last name is required."),
    email_id: Yup.string().email("Email must be a valid email"),
  });

  const initialValues = {
    first_name: first_name || "",
    last_name: last_name || "",
    email_id: email_id || "",
    profileImage: "",
    profileFile: "",
  };

  let newWallet = "";

  if (address) {
    newWallet = `${address.substring(0, 6)}...${address.substring(
      address.length - 4,
      address.length
    )}`;
  }

  return (
    <div id="admin-container" className="cps-38 cpe-38 cpt-26 cpb-24 d-flex flex-column">
      {isDeletePopup && (
        <Modal
          title="Delete Account"
          width="600px"
          onHide={() => {
            setIsDeletePopup(false);
          }}
          isDarkMode={isDarkMode}
        >
          <div className="cps-26 cpe-26 cpt-26 cmb-10">
            <div className="h-175 cmb-26">
              <img
                src={isDarkMode ? icons.deleteFrameLight : icons.deleteFrame}
                alt="deleteFrame"
                className="fit-image"
              />
            </div>
            <div className={`text-center text-18-600 ${isDarkMode ? "color-ffff" : "color-2749"} cmb-10`}>
              Delete Confirmation !
            </div>
            <div className={`text-center text-16-400 ${isDarkMode ? "color-c9c9" : "color-7e91"} cmb-26`}>
              Are you sure you want to delete <br />
              this account
            </div>
            <div className="f-center gap-3">
              <Button
                btnStyle="GD"
                btnText="Cancel"
                className="cps-45 cpe-45"
                onClick={() => {
                  setIsDeletePopup(false);
                }}
              />
              <Button
                btnStyle="RD"
                btnText="Delete Account"
                loading={deleteLoader}
                onClick={handleDelete}
              />
            </div>
          </div>
        </Modal>
      )}
      <div >
        <Formik
          enableReinitialize
          onSubmit={handleSave}
          initialValues={initialValues}
          validationSchema={validationSchema}>
          {(props) => {
            const { values, errors, handleChange, handleSubmit } = props;
            const { first_name, last_name, email_id, profileFile, profileImage } =
              values;
            const {
              first_name: errFirstName,
              last_name: errLastName,
              email_id: errEmailId,
            } = errors;
            return (
              <form>
                {profileFile && (
                  <ImageCropper
                    id="userProfile"
                    onHide={() => {
                      handleChange({
                        target: {
                          id: "profileFile",
                          value: "",
                        },
                      });
                    }}
                    fileURL={profileFile}
                    handelCropImage={(e) => {
                      handleChange({
                        target: {
                          id: "profileImage",
                          value: e?.target?.urlString,
                        },
                      });
                    }}
                  />
                )}
                <div className="fb-center">
                  <div className={`text-20-700 ${isDarkMode ? "color-ffff" : "color-2749"}`}>
                    {isEdit ? "Edit Profile" : "Profile"}
                  </div>
                  <Button
                    btnStyle="PD"
                    loading={btnLoading}
                    leftIcon={icons.editLight}
                    btnText={isEdit ? "Save Changes" : "Edit Profile"}
                    onClick={(e) => {
                      if (isEdit && !isEqual(values, initialValues)) {
                        handleSubmit(e);
                      } else {
                        setIsEdit(!isEdit);
                      }
                    }}
                  />
                </div>
                <div className={`${isDarkMode ? "bg-102a" : "bg-faff"} cp-24 cmt-24`}>
                  <div className="d-flex gap-4">
                    <div className="w-130">
                      <div className={`text-16-400 ${isDarkMode ? "color-ffff" : "color-2749"} cmb-10`}>
                        Profile Image
                      </div>
                      <div className="w-130 position-relative">
                        <img
                          src={profileImage || icons.user}
                          alt="use"
                          className="fit-image rounded-circle"
                        />
                        {true && (
                          <span className="h-30 selection-container">
                            <img
                              src={icons.profileSelection}
                              alt="profileSelection"
                              className="fit-image"
                            />
                            <input
                              className="file_upload"
                              type="file"
                              onChange={(e) => {
                                var files = e?.target?.files;
                                var extension = files[0]?.type;

                                if (
                                  [
                                    "image/png",
                                    "image/jpg",
                                    "image/jpeg",
                                  ].includes(extension)
                                ) {
                                  if (e?.target?.files[0]) {
                                    handleChange({
                                      target: {
                                        id: "profileFile",
                                        value: URL.createObjectURL(
                                          e?.target?.files[0]
                                        ),
                                      },
                                    });
                                  }
                                } else {
                                  dispatch(
                                    throwError(
                                      "Invalid file select. (PNG || JPG || JPEG)"
                                    )
                                  );
                                }
                              }}
                            />
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="flex-grow-1 row">
                      {address && (
                        <div className="cmb-24">
                          <div className={`text-16-400 ${isDarkMode ? "color-ffff" : "color-2749"} mb-2`}>
                            Wallet Address
                          </div>
                          <div className="fb-center gap-3">
                            <div className={`text-14-400 ${isDarkMode ? "color-ffff b-4d6c" : "color-2749 b-dee3"} ${isDarkMode ? "bg-4d6c" : "bg-ffff"}  cpt-14 cpb-14 cps-14 flex-grow-1 br-8 un`}>
                              {newWallet}
                            </div>
                            <div>
                              <Button
                                btnStyle="PD"
                                leftIcon={icons.copy}
                                className={isCopy ? "" : "cps-28 cpe-28"}
                                btnText={isCopy ? "Copied" : "Copy"}
                                onClick={() => {
                                  copyToClipboard(address);
                                  setIsCopy(true);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="col-md-6 cmb-24">
                        <Label label="First Name" />
                        <div className={`${isDarkMode ? "admin-input-block-dark" : "admin-input-block"}`}>
                          <input
                            type="text"
                            placeholder="Enter first name"
                            value={first_name}
                            id={"first_name"}
                            disabled={!isEdit}
                            onChange={handleChange}
                            error={errFirstName}
                            maxLength="40"
                          />
                        </div>
                      </div>
                      <div className="col-md-6 cmb-24">
                        <Label label="Last Name" />
                        <div className={`${isDarkMode ? "admin-input-block-dark" : "admin-input-block"}`}>
                          <input
                            type="text"
                            placeholder="Enter last name"
                            value={last_name}
                            id={"last_name"}
                            disabled={!isEdit}
                            onChange={handleChange}
                            error={errLastName}
                            maxLength="30"
                          />
                        </div>
                      </div>
                      <div className="cmb-24">
                        <Label label="Email Address" />
                        <div className={`${isDarkMode ? "admin-input-block-dark" : "admin-input-block"}`}>
                          <input
                            type="text"
                            placeholder="Enter email id"
                            value={email_id}
                            id={"email_id"}
                            disabled={!isEdit}
                            onChange={handleChange}
                            error={errEmailId}
                            maxLength="60"
                          />
                        </div>
                      </div>
                      {/* <div className="col-md-6 cmb-24">
                        <Textinput
                          label="First name"
                          placeholder="Enter first name"
                          value={first_name}
                          id={"first_name"}
                          disabled={!isEdit}
                          onChange={handleChange}
                          error={errFirstName}
                        />
                      </div>
                      <div className="col-md-6 cmb-24">
                        <Textinput
                          label="Last name"
                          placeholder="Enter last name"
                          value={last_name}
                          id={"last_name"}
                          disabled={!isEdit}
                          onChange={handleChange}
                          error={errLastName}
                        />
                      </div>
                      <div className="cmb-24">
                        <Textinput
                          label="Email Address"
                          placeholder="Enter email id"
                          value={email_id}
                          id={"email_id"}
                          disabled={!isEdit}
                          onChange={handleChange}
                          error={errEmailId}
                        />
                      </div> */}
                      <div className="fb-center">
                        <div className="d-flex gap-2">
                          <span className="d-flex h-20">
                            <img
                              src={isDarkMode ? icons.infoCircleLight : icons.infoCircle}
                              alt="infoCircle"
                              className="fit-image"
                            />
                          </span>
                          <span className={`text-16-400 ${isDarkMode ? "color-ffff" : "color-2749"} un`}>
                            All info is private/optional and will only be used for
                            service notifications/never sold or shared
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </div>
      <div className="flex-grow-1 d-flex align-items-end">
        <Button
          btnStyle="RD"
          btnText="Delete Account"
          loading={deleteLoader}
          onClick={() => {
            setIsDeletePopup(true);
          }}
        />
      </div>
    </div>
  );
};

export default Admin;
